<template lang="html">
  <div class="orange">
    <ModalForm :showModal="showModal" :action="ProductCharge.wizard.action">
      <template slot="form">
        <CustomForm
          :pages="ProductCharge.wizard.pages"
          :action="ProductCharge.wizard.action"
          :buttonText="ProductCharge.wizard.actionBtn"
          :showTitle="false"
        >
        </CustomForm>
      </template>
    </ModalForm>

    <div
      class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30"
    >
      <div></div>
      <div class="d-none d-md-block">
        <button
          class="btn btn-sm pd-x-15 btn-white btn-uppercase"
          @click="openAddChargeModal()"
        >
          <i data-feather="mail" class="wd-10 mg-r-5"></i> Add Product Charge
        </button>
      </div>
    </div>

    <div class="contents">
      <CustomTable
        :tableFields="ProductCharge.table.table_fields"
        :tableData="charges"
        :title="ProductCharge.table.title"
        :subtitle="ProductCharge.table.subtitle"
        :searchFields="ProductCharge.table.searchFields"
        :rowData="ProductCharge.table.rowData"
      >
      </CustomTable>
    </div>
  </div>
</template>

<script>
export default {
  async created() {
    this.ProductCharge = Models.ProductCharge;
    let _this = this;

    this.charges = [];

    // if specified action is complete clear form data and stop loader
    Event.$on('form:submit', async (payload) => {
      if (payload.action === this.ProductCharge.wizard.action) {
        await this.addProductCharge(payload.formData);
        this.showModal = false;
      }
    });

    Event.$on('modal:close', async (payload) => {
      console.log('Closing modal');
      this.showModal = false;
    });
  },
  data() {
    return {
      ProductCharge: {},
      charges: [],
      formData: {},
      showModal: false,
    };
  },
  methods: {
    addProductCharge(data) {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await req.callServerSecure({
            resource: 'product_charge',
            action: 'add',
            data: {
              charge_code: data.code,
              charge_name: data.name,
              charge_description: data.description,
              charge_type: data.type,
              value: data.val,
              slab: [],
              account_opening_template: data.account_opening_template,
            },
          });

          await this.fetchProductCharges();
          notification.notify(
            'success',
            'Product Charge Added',
            `Product Charge ${data.name} successfully added`
          );
          Event.$emit('form:action-complete', {
            action: this.ProductCharge.wizard.action,
            clear: true,
          });
          this.showModal = false;
        } catch (err) {
          console.log(err);
          Event.$emit('form:action-error', {
            action: this.ProductCharge.wizard.action,
          });
        }
      });
    },
    fetchProductCharges() {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await req.callServerSecure({
            resource: 'product_charge',
            action: 'list',
            data: {},
            meta_data: {},
          });

          this.charges = res.data.result.charges;
          resolve(true);
        } catch (err) {
          reject(err);
        }
      });
    },
    fetchAccountOpeningTemplate() {
      return new Promise(async (resolve, reject) => {
        try {
          let pages = this.ProductCharge.wizard.pages;

          let res = await req.callServerSecure({
            resource: 'entity_account_template',
            action: 'get',
            data: {
              entity_type: 'PRODUCT',
            },
            meta_data: {},
          });

          pages[0].forms[4].options = utils.appendOptions(
            res.data.result.templates,
            'template_code',
            'template_name'
          );

          this.ProductCharge.wizard.pages = pages;

          resolve(true);
        } catch (err) {
          reject(err);
        }
      });
    },
    openAddChargeModal() {
      this.showModal = true;
    },
  },
  async mounted() {
    await this.fetchAccountOpeningTemplate();
    await this.fetchProductCharges();
    Event.$emit('loader:show', false);
  },
};
</script>

<style lang="less">
.orange {
}
</style>
